export default "__VITE_ASSET__C9waa7zP__"